module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.9 8.3"}},[_c('title',[_v("chevron-down")]),_c('path',{attrs:{"d":"M7.9 8.3L0 .4.3.1l7.6 7.5L15.6 0l.3.3z"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/white-chevron-down.svg
// module id = 437
// module chunks = 1